import React, { useState } from 'react';
import './login.css';
import AppLogoDark from '../../../assets/v2/logos/NewLogo.png';
import { Link } from 'react-router-dom';
import { IUser } from '../../../interfaces/IUser';
import useApiRequests from '../../../hooks/useApiRequests';
import useChangeTextById from '../../../hooks/useChangeTextById.tsx';
import { handleFieldChange, handleWithLogin, } from './Login.ts';

const LoginForm: React.FC<{ type: number }> = ({ type }) => {
    const { loading, signUp, signIn, authWithCode } = useApiRequests();
    const [buttonText, setButtonText] = useState(type === 0 ? "Entrar" : type === 1 ? "Login" : "Cadastrar");
    //Para usar o hook basta colocar o state como o buttonText
    useChangeTextById('button-signup-signin', buttonText);

    const [user, setUser] = useState<IUser>({
        id: '',
        email: '',
        username: '',
        password: '',
        code: ''
    });

    const handleButtonClick = () => {
        handleWithLogin(type, user, setButtonText, signUp, signIn, authWithCode, loading);
    };

    const userRef = React.useRef(user);
    const handleButtonClickRef = React.useRef(handleButtonClick);

    React.useEffect(() => {
        userRef.current = user;
        handleButtonClickRef.current = handleButtonClick;
    }, [user, handleButtonClick]);
        
    const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleButtonClickRef.current();
        }
    };

    React.useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const getTitle = () => {
        switch(type) {
            case 0: return "Bem-vindo de volta";
            case 1: return "Faça login na sua conta";
            case 2: return "Crie sua conta";
            default: return "Bem-vindo";
        }
    };

    const getSubtitle = () => {
        switch(type) {
            case 0: return "Digite seu código de acesso para continuar";
            case 1: return "Digite suas credenciais para acessar o sistema";
            case 2: return "Preencha os dados para criar sua conta";
            default: return "";
        }
    };

    return (
        <div className='login-page'>
            <div className='login-container'>
                <div className='login-logo'>
                    <img src={AppLogoDark} alt='VendaERP Tracker' />
                </div>

                <h1 className='login-title'>{getTitle()}</h1>
                <p className='login-subtitle'>{getSubtitle()}</p>

                <form className='login-form' onSubmit={(e) => e.preventDefault()}>
                    {type === 0 ? (
                        // Formulário de código
                        <div className='form-group'>
                            <label className='form-label'>Código de Acesso</label>
                            <input
                                type="text"
                                value={user.code}
                                onChange={(e) => handleFieldChange(e, 'code', user, setUser)}
                                className='form-input'
                                placeholder='Digite seu código'
                                autoFocus
                            />
                        </div>
                    ) : (
                        // Formulário de login/cadastro
                        <>
                            {type === 2 && (
                                <div className='form-group'>
                                    <label className='form-label'>Nome</label>
                                    <input
                                        type="text"
                                        value={user.username}
                                        onChange={(e) => handleFieldChange(e, 'username', user, setUser)}
                                        className='form-input'
                                        placeholder='Digite seu nome completo'
                                        autoFocus
                                    />
                                </div>
                            )}
                            <div className='form-group'>
                                <label className='form-label'>Email</label>
                                <input
                                    type="email"
                                    value={user.email}
                                    onChange={(e) => handleFieldChange(e, 'email', user, setUser)}
                                    className='form-input'
                                    placeholder='exemplo@empresa.com'
                                    autoFocus={type !== 2}
                                />
                            </div>
                            <div className='form-group'>
                                <label className='form-label'>Senha</label>
                                <input
                                    type="password"
                                    value={user.password}
                                    onChange={(e) => handleFieldChange(e, 'password', user, setUser)}
                                    className='form-input'
                                    placeholder='Digite sua senha'
                                />
                            </div>
                        </>
                    )}

                    <button 
                        type="button"
                        id="button-signup-signin"
                        onClick={handleButtonClick}
                        className='login-button'
                        disabled={loading}
                    >
                        {loading ? 'Carregando...' : buttonText}
                    </button>
                </form>

                <div className='login-links'>
                    {type === 0 ? (
                        <Link to='/signin' className='login-link'>
                            Sou Administrador
                        </Link>
                    ) : (
                        <>
                            <Link to='/code' className='login-link'>
                                Tenho um código de acesso
                            </Link>
                        </>
                    )}
                </div>

                <div className='help-text'>
                    Precisa de ajuda? Entre em contato com o suporte
                </div>
            </div>
        </div>
    );
};

export default LoginForm;
